module.exports = __webpack_public_path__ + "img/roof-repair-exterior-maintenance-06-large.50391925.jpg";